import _ from 'lodash-es';
import kformUtils from '~/components/kform/utils/kform-utils';

const kformBuilderConditionalController = /* @ngInject */ (/** @type {any} */ $scope) => {
	// Default the current components conditional logic.
	$scope.component = $scope.component || {};
	$scope.component.conditional = $scope.component.conditional || {};

	// The available logic functions.
	// eslint-disable-next-line no-underscore-dangle
	$scope._booleans = ['', 'true', 'false'];

	// Filter the list of available form components for conditional logic.
	// eslint-disable-next-line no-underscore-dangle
	$scope._components = _.get($scope, 'form.components') || [];
	// eslint-disable-next-line no-underscore-dangle
	$scope._components = kformUtils.flattenComponents($scope._components);
	// Remove non-input/button fields because they don't make sense.
	// FA-890 - Dont allow the current component to be a conditional trigger.
	// eslint-disable-next-line max-len,no-underscore-dangle
	$scope._components = _.reject($scope._components, c => !c.input || (c.type === 'button') || (c.key === $scope.component.key) || (!c.label && !c.key));

	// Add default item to the components list.
	// eslint-disable-next-line no-underscore-dangle
	$scope._components.unshift('');

	// Default and watch the show logic.
	$scope.component.conditional.show = $scope.component.conditional.show || '';
	// Coerce show var to supported value.
	/** @type {any} */
	// eslint-disable-next-line no-underscore-dangle
	const _booleanMap = {
		'': '',
		true: 'true',
		false: 'false',
	};
	$scope.component.conditional.show
		= Object.prototype.hasOwnProperty.call(_booleanMap, $scope.component.conditional.show)
			? _booleanMap[$scope.component.conditional.show] : '';

	// Default and watch the when logic.
	$scope.component.conditional.when = $scope.component.conditional.when || null;

	// Default and watch the search logic.
	$scope.component.conditional.eq = $scope.component.conditional.eq || '';

	// Track the status of the accordion panels open state.
	$scope.status = {
		simple: !$scope.component.customConditional,
		advanced: !!$scope.component.customConditional,
	};
};

export default kformBuilderConditionalController;
